export default __webpack_public_path__ + "static/media/curtain.c9ec8b3b.jpg";